import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getImagesTime = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/images_time', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getImagesTimeAll = () => {
  return api.http.get(`/images_time/select_search`)
}

export const getImageTime = id => {
  return api.http.get(`/images_time/${id}`)
}

export const searchImagesTime = term => {
  return api.http.get('/images_time/select_search', {
    params: {
      term
    }
  })
}

export const getSelectImagesTime = (term, callback) => {
  searchImagesTime(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteImageTime = id => {
  return api.http.delete(`/images_time/${id}`)
}

export const restoreImageTime = id => {
  return api.http.put(`/images_time/${id}/restore`)
}

export const editImageTime = imageTime => {
  return api.http.put(`/images_time/${imageTime._id}`, imageTime)
}

export const addImageTime = imageTime => {
  return api.http.post('/images_time', imageTime)
}



// WEBPACK FOOTER //
// ./src/api/imagesTime.js